let setting=JSON.parse(localStorage.getItem('th_default_settings_content'));
let th_single_products_added_callback=()=>{
  console.log("call")
  // let th_wl_add_to_cart_btns=document.querySelectorAll('.th-wl-product-add-to-cart');
  // th_wl_add_to_cart_btns.forEach((add_btn)=>{
  //   let loading_spinner=add_btn.querySelector('#loading-spinner');
  //   if(loading_spinner){
  //     if(setting.data.setting.add_to_cart!=undefined){
  //        add_btn.innerHTML=`<span>${setting.data.setting.add_to_cart}</span>`;
  //     }else{
  //        add_btn.innerHTML='Add To cart';
  //     }
  //   }
  // })
   let th_wl_add_to_cart_btns=document.querySelectorAll('.new_add_to_cart_btn');
   th_wl_add_to_cart_btns.forEach((new_add_to_cart_btn)=>{
     if(setting.data.setting.add_to_cart!=undefined){
         new_add_to_cart_btn.innerHTML=`<span>${setting.data.setting.add_to_cart}</span>`;
      }else{
         new_add_to_cart_btn.innerHTML='Add To cart';
      }
   })
   document.querySelector('body').insertAdjacentHTML('beforeend', `<div id="th-wl-sucess-mgs">${setting.data.setting.product_add_to_cart}</div></div>`);
   setTimeout(function () { document.getElementById("th-wl-sucess-mgs").remove(); }, 4000);
}


let th_wl_trigger_main_add_to_cart_btn=(new_add_to_cart_btn)=>{
  let grid_containor=new_add_to_cart_btn.closest('.th-wl-product-item');
  let real_add_to_cart_btn=grid_containor.querySelector('.th-wl-product-add-to-cart');
  if(real_add_to_cart_btn){
    real_add_to_cart_btn.click();
    let loader=`<svg id="loading-spinner" width="18" height="18" viewBox="0 0 48 48"><g fill="none"><path id="track" fill="#C6CCD2" d="M24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 Z M24,44 C35.045695,44 44,35.045695 44,24 C44,12.954305 35.045695,4 24,4 C12.954305,4 4,12.954305 4,24 C4,35.045695 12.954305,44 24,44 Z"></path><path id="section" fill="#000000" d="M24,0 C37.254834,0 48,10.745166 48,24 L44,24 C44,12.954305 35.045695,4 24,4 L24,0 Z"></path></g></svg>`
    new_add_to_cart_btn.innerHTML=loader;

    setTimeout(()=>{
      let loading_spinner=new_add_to_cart_btn.querySelector('#loading-spinner');
      if(loading_spinner){
         if(setting.data.setting.add_to_cart!=undefined){
         new_add_to_cart_btn.innerHTML=`<span>${setting.data.setting.add_to_cart}</span>`;
        }else{
           new_add_to_cart_btn.innerHTML='Add To cart';
        }
      }
    },5000)
  }
}

let add_new_add_to_cart_btns=()=>{
    let th_wl_add_to_cart_btns=document.querySelectorAll('.th-wl-product-add-to-cart');
     th_wl_add_to_cart_btns.forEach((add_to_cart_btn)=>{
        let grid_containor=add_to_cart_btn.closest('.th-wl-product-item');
        let grid_containor_already_contains_new_add_to_cart=grid_containor.querySelector('.new_add_to_cart_btn');
       if(!add_to_cart_btn.classList.contains('th-wl-product-sold-out') && !grid_containor_already_contains_new_add_to_cart){
        add_to_cart_btn.style.display='none';
       let new_add_to_cart_btn=`<div class='new_add_to_cart_btn th-wl-product-add-to-cart' onClick='th_wl_trigger_main_add_to_cart_btn(this)'>${setting.data.setting.add_to_cart!=undefined ?setting.data.setting.add_to_cart : 'Add to Cart' }</div>`;
       add_to_cart_btn.insertAdjacentHTML("afterend",new_add_to_cart_btn);
       }
     })
}

let wc_wishlist_items_added_callback=()=>{
   setTimeout(()=>{
    add_new_add_to_cart_btns();


    let tab_links=document.querySelectorAll('.tab-link'); 
    tab_links.forEach((tab_link)=>{
       tab_link.addEventListener('click',()=>{
      add_new_add_to_cart_btns();
    })
    })
   },1000)
}